const template = {
	choose_template: "Betriebssystem oder Anwendung auswählen",
	default_category: "Andere",
	information_dialog: {
		title: "Mehr Infomationen über Vorlage ",
	},
	other_os:
		"Ist ein Betriebssystem nicht als Vorlage verfügbar? Wir können möglicherweise Ihre ISO-Datei hochladen. Bitte erstellen Sie eine Anfrage. Klicken Sie hier.",
	title: "Neuen VPS erstellen",
};

export default template;
